import {Component, inject, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-header-light',
  templateUrl: './header-light.component.html',
  styleUrls: ['./header-light.component.scss']
})
export class HeaderLightComponent implements OnInit {
  private readonly router = inject(Router);
  constructor() { }

  ngOnInit(): void {
  }

  shouldShowCross(): boolean {
    return !this.router.url.startsWith('/book-viewing');
  }
}
